import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyAlertsPageComponent } from './components/company-alerts-page/company-alerts-page.component';
import { SharedModule } from '../shared/shared.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { EntityAlertTypeStringPipe } from './pipes/entity-alert-type-string.pipe';
import { AlertNoticeLevelStringPipe } from './pipes/alert-notice-level-string.pipe';
import { SupervisionAlertsPageComponent } from './components/supervision-alerts-page/supervision-alerts-page.component';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { PanelModule } from 'primeng/panel';


@NgModule({
  declarations: [CompanyAlertsPageComponent, EntityAlertTypeStringPipe, AlertNoticeLevelStringPipe, SupervisionAlertsPageComponent],
  imports: [
    CommonModule,
    SharedModule,
    FontAwesomeModule,
    TableModule,
    RouterModule,
    FormsModule,
    MultiSelectModule,
    InputTextModule,
    ButtonModule,
    RippleModule,
    ReactiveFormsModule,
    PanelModule
  ]
})
export class AlertsModule { }
